import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer id="main-footer" className="main-footer main-footer--page">
      <div className="inner">
        <div className="main-footer__flex">
          <ul className="main-footer__menu">
            <li className="main-footer__menu-item"><a href="/facility/company_overview">会社概要</a></li>
            <li className="main-footer__menu-item"><a href="/facility/terms_of_use">ご利用規約</a></li>
            <li className="main-footer__menu-item"><a href="/facility/privacy_policy">プライバシーポリシー</a></li>
          </ul>
          <p className="main-footer__copyright">Copyright &copy; SEED Co., Ltd. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer;